import { createAsyncTypes } from 'utils/ActionCreator'

const BASE_TYPE = 'EmailEncryption/Branding'

export const FETCH_BRANDING_ASYNC = createAsyncTypes('FETCH_BRANDING', BASE_TYPE)
export const FETCH_TENANT_DOMAINS_ASYNC = createAsyncTypes('FETCH_TENANT_DOMAINS', BASE_TYPE)
export const SAVE_BRANDING_ASYNC = createAsyncTypes('SAVE_BRANDING', BASE_TYPE)
export const SELECT_DOMAIN = `${BASE_TYPE}/SELECT_DOMAIN`
export const RESET_SAVE_SUCCESS = `${BASE_TYPE}/RESET_SAVE_SUCCESS`
